module.exports = __webpack_public_path__ + "img/station-single-triggered.7b4badf8.png";